import { enums } from '@optimizely/react-sdk';

const customLogger = (level, message) => {
  const { LOG_LEVEL } = enums;

  switch (level) {
    case LOG_LEVEL.INFO:
    case LOG_LEVEL.DEBUG:
      // eslint-disable-next-line no-console
      console.log(message);
      break;

    case LOG_LEVEL.WARNING:
      console.warn(message);
      break;

    case LOG_LEVEL.ERROR:
      if (!message.includes(' is not in datafile.')) {
        // eslint-disable-next-line no-console
        console.error(message);
      }
      break;

    default:
      // eslint-disable-next-line no-console
      console.log(message);
  }
};

export default customLogger;
